(() => {
  "use strict";

  const accordion = document.getElementById('faqAccordion');
  if (!accordion) return;

  const detailsList = accordion.querySelectorAll('details');
  const expandBtn = document.getElementById('faqExpandAll');
  const collapseBtn = document.getElementById('faqCollapseAll');

  // State flag: controls whether the "one-at-a-time" rule applies
  let autoCloseEnabled = true;

  // ------------------------------------------------------------
  // 1. Accordion Click Logic ("One Open at a Time")
  // ------------------------------------------------------------
  detailsList.forEach((targetDetail) => {
    targetDetail.addEventListener('toggle', () => {
      // Only execute auto-close logic if autoCloseEnabled is true and item was OPENED
      if (autoCloseEnabled && targetDetail.open) {
        detailsList.forEach((detail) => {
          if (detail !== targetDetail && detail.open) {
            detail.removeAttribute('open');
          }
        });
      }
    });
  });

  // ------------------------------------------------------------
  // 2. Expand All Button
  // ------------------------------------------------------------
  if (expandBtn) {
    expandBtn.addEventListener('click', (e) => {
      e.preventDefault();
      // Temporarily disable auto-close so opening all doesn't trigger the toggle loop
      autoCloseEnabled = false;

      detailsList.forEach((detail) => {
        detail.setAttribute('open', '');
      });
    });
  }

  // ------------------------------------------------------------
  // 3. Collapse All Button
  // ------------------------------------------------------------
  if (collapseBtn) {
    collapseBtn.addEventListener('click', (e) => {
      e.preventDefault();

      detailsList.forEach((detail) => {
        detail.removeAttribute('open');
      });

      // Re-enable auto-close logic for future clicks
      autoCloseEnabled = true;
    });
  }
})();